import PropTypes from 'prop-types';

import TruncatedTextWithTooltip from '#/modules/commonComponents/table/TruncatedTextWithTooltip';
import { formatCostEstimateDecimal } from '#/modules/crmMgmt/costEstimate/helper/costEstimateFormat';

const HEADERS = ['#', '料號', '名稱', '基礎單位', '數量', '單價', '列金額', '備註'];

/** 成本試算明細（唯讀）；料號／名稱／單位為後端快照。 */
const CostEstimateLinesSection = ({ detail }) => {
  const lines = detail.lines ?? [];

  return (
    <div className="receipt-card-elevate">
      <div className="receipt-card-surface p-5">
        <h2 className="text-base font-semibold text-gray-900">試算明細</h2>
        {lines.length === 0 ? (
          <p className="mt-3 text-sm text-muted-foreground">尚無明細。</p>
        ) : (
          <div className="mt-3 overflow-x-auto rounded border border-slate-200">
            <table className="w-full min-w-[48rem] text-left text-sm">
              <thead className="bg-slate-100 text-xs text-gray-600">
                <tr>
                  {HEADERS.map((header) => (
                    <th key={header} className="px-2 py-1.5 font-medium whitespace-nowrap">
                      {header}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-200">
                {lines.map((line, index) => (
                  <tr key={line.lineId}>
                    <td className="px-2 py-1.5 tabular-nums text-gray-500">{index + 1}</td>
                    <td className="px-2 py-1.5 whitespace-nowrap">{line.mtr?.mtrNo || '-'}</td>
                    <td className="max-w-64 px-2 py-1.5">
                      <TruncatedTextWithTooltip text={line.mtr?.name || '-'} />
                    </td>
                    <td className="px-2 py-1.5">{line.mtr?.baseUnit?.name || '-'}</td>
                    <td className="px-2 py-1.5 text-right tabular-nums">
                      {formatCostEstimateDecimal(line.qty)}
                    </td>
                    <td className="px-2 py-1.5 text-right tabular-nums">
                      {formatCostEstimateDecimal(line.unitPrice)}
                    </td>
                    <td className="px-2 py-1.5 text-right tabular-nums">
                      {formatCostEstimateDecimal(line.lineAmount)}
                    </td>
                    <td className="max-w-56 px-2 py-1.5">
                      <TruncatedTextWithTooltip text={line.remark || '-'} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

CostEstimateLinesSection.propTypes = {
  detail: PropTypes.object.isRequired,
};

export default CostEstimateLinesSection;
